/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auto_ReplacementInputs */



/**
* | output |
* | --- |
* | "Auto Replacement" |
*
* @param {Auto_ReplacementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const auto_replacement = /** @type {((inputs?: Auto_ReplacementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_ReplacementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacement automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Autoersatz")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituzione auto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автозамена")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazo de Auto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("汽车更换")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動交換")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो रिप्लेसमेंट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Substituição de automóveis")
	return /** @type {LocalizedString} */ ("Auto Replacement")
});